/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless secondary written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');
var GetSalesCompensationByRecord = require('../services/GetSalesCompensationByRecord');
var CorpFinSalesCompensationSectionView = require('../views/CorpFinSalesCompensationSectionView');

module.exports = {
  channel: 'cf',

  event: 'build:corp-fin-sales-compensation-section-view',

  builder: function(recordId, isReadOnly) {
    return new PlaceholderView({
      viewPromise: buildCorpFinSalesCompensationSectionView(recordId, isReadOnly)
    });
  }
};

function buildCorpFinSalesCompensationSectionView(recordId, isReadOnly) {
  var deferred = $.Deferred();
  GetSalesCompensationByRecord(recordId)
    .done(function(salesCompensations) {
      deferred.resolve(
        new CorpFinSalesCompensationSectionView({
          collection: new PageableCollection(salesCompensations, { pageSize: 25 }),
          isReadOnly: isReadOnly
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
